import PhoneScreenshot from './PhoneScreenshot'

/** CleanDock calendar — shown on the scheduling & recurring stage. */
const WeekCalendarScreen = () => (
  <PhoneScreenshot src="/LandingPhoneMock/Calendar.PNG" alt="CleanDock schedule calendar" />
)

export default WeekCalendarScreen
